import { render, staticRenderFns } from "./seo-content-collapsible-mazda.vue?vue&type=template&id=662a59a5&scoped=true&"
import script from "./seo-content-collapsible-mazda.vue?vue&type=script&lang=js&"
export * from "./seo-content-collapsible-mazda.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=662a59a5&scoped=true&lang=css&"
import style1 from "./seo-content-collapsible-mazda.vue?vue&type=style&index=1&id=662a59a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a59a5",
  null
  
)

export default component.exports